import NR1DashboardsHub from "@/pages/NR1DashboardsHub";

export default function DashboardsHubConsultor() {
  return <NR1DashboardsHub forcedVariant="consultor" />;
}
